// src/pages/Vendors.jsx
import React from 'react';
import { motion } from 'framer-motion';

const clientLogos = [
  '/Logos/Kohinoor.png',
  '/Logos/Unique_Group.png',
  '/Logos/Triaa.png',
  '/Logos/Saheel_Properties.png',
  '/Logos/Tayal_corp.jpg.jpeg',
  '/Logos/Jhamtani.jpg.jpeg',
  '/Logos/Ranawat_Group.png',
  '/Logos/Oree_Reality.png',
  '/Logos/Chandrarang.png',
  '/Logos/Skyi.jpg.jpeg',
  '/Logos/Goel_Ganga_Development.png',
  '/Logos/DPU.png',
  '/Logos/Fidesto.jpg.jpeg',
  '/Logos/Shriram_Properties.jpg.jpeg',
  '/Logos/City_One.jpg.jpeg',
  '/Logos/GKG_Venture.jpg.jpeg',
  '/Logos/Namrata_Group.png',
  '/Logos/Miracle_Developers.jpg.jpeg',
  '/Logos/Vighnharta.jpg.jpeg',
  '/Logos/Shubh_Developers.jpg.jpeg',
  '/Logos/Naiknaware.png',
  '/Logos/Raviraj.jpg.jpeg',
  '/Logos/Aswani.png',
  '/Logos/Kiran_Creators.png',  
  '/Logos/Reliance.png',
  '/Logos/Toyota.png',
  '/Logos/Skoda.png',
  '/Logos/Honda.png',
  '/Logos/Urway_Group.png',
  '/Logos/Kumar_Realty.jpg.jpeg',
  '/Logos/Oxy_Buildcorp.jpg.jpeg',
  '/Logos/Achalare_Realtors.png',
  '/Logos/Prism_City.jpg.jpeg',
  '/Logos/Marvel_Realtors.png',
  '/Logos/Profile_Group.png',
  '/Logos/Amegh_Properties.png',
  '/Logos/Krisala.png',
];

const architectLogos = [
  '/Logos/Planedge.png',
  '/Logos/Vka_Architects.jpg.jpeg',
  '/Logos/Landmark_Architects_Design.jpg.jpeg',
  '/Logos/Design_11.jpg.jpeg',
  '/Logos/WK_Architects.png',
  '/Logos/IP_Associates.jpg.jpeg',
  '/Logos/Space_Craft.jpg.jpeg',
  '/Logos/Ankur_Associates.jpg.jpeg',
  '/Logos/Samyak.jpg.jpeg',
  '/Logos/Cubix_Architects.jpg.jpeg',
];

const Vendors = ({ noMargin }) => (
  <div className="min-h-screen bg-gradient-to-b from-gray-900 via-gray-800 to-gray-900 flex flex-col items-center justify-start py-10" style={noMargin ? undefined : { marginTop: "90px" }}>
    <h1 className="text-3xl md:text-4xl font-bold text-white text-center font-sans mb-8">Vendors</h1>
    <div className="w-11/12 max-w-6xl flex flex-col">
      <div className="mb-6">
        <h2 className="text-3xl md:text-4xl font-bold text-white text-left font-sans">Clients</h2>
      </div>
      <motion.div
        className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-y-8 gap-x-12 justify-items-center items-center"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        variants={{
          visible: { transition: { staggerChildren: 0.08 } },
          hidden: {}
        }}
      >
        {clientLogos.map((logo, idx) => (
          <motion.div
            key={idx}
            className="bg-black rounded-xl p-4 flex items-center justify-center shadow-sm hover:shadow-lg transition-shadow duration-300"
            variants={{
              hidden: { opacity: 0, y: 40 },
              visible: { opacity: 1, y: 0, transition: { type: 'spring', stiffness: 60, damping: 18, duration: 0.7 } }
            }}
          >
            <div className="bg-black rounded-lg p-3 flex items-center justify-center w-[120px] h-[72px]">
              <img
                src={logo}
                alt={`Vendor logo ${idx + 1}`}
                className="max-w-[105px] max-h-[60px] object-contain drop-shadow-lg transition-transform duration-300 hover:scale-105"
              />
            </div>
          </motion.div>
        ))}
      </motion.div>
    </div>
    <div className="w-11/12 max-w-6xl mt-12">
      <h2 className="text-2xl md:text-3xl font-bold text-white text-left font-sans mb-6">Architects</h2>
      <motion.div
        className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-y-8 gap-x-12 justify-items-start items-center"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        variants={{
          visible: { transition: { staggerChildren: 0.08 } },
          hidden: {}
        }}
      >
        {architectLogos.map((img, idx) => (
          <motion.div
            className="bg-black rounded-xl p-4 flex items-center justify-center shadow-sm hover:shadow-lg transition-shadow duration-300"
            key={idx}
            variants={{
              hidden: { opacity: 0, y: 40 },
              visible: { opacity: 1, y: 0, transition: { type: 'spring', stiffness: 60, damping: 18, duration: 0.7 } }
            }}
          >
            <div className="bg-black rounded-lg p-3 flex items-center justify-center w-[120px] h-[72px]">
              <img
                src={img}
                alt={`Architect logo ${idx + 1}`}
                className="max-w-[105px] max-h-[60px] object-contain drop-shadow-lg"
              />
            </div>
          </motion.div>
        ))}
      </motion.div>
    </div>
  </div>
);

export default Vendors;
